import { state, els } from "./state.js";
import { getCookie, createDiacriticPattern, findMarkerByLatLng, toggleLoading } from "./utils.js";
import { resetMap } from "./map.js";
import { ApiService } from "../../services/ApiService.js";
// Import Swiper and required modules
import Swiper from "swiper";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import { Fancybox } from "@fancyapps/ui";
import {
  expandBottomSheet,
  collapseBottomSheet,
  fullScreenBottomSheet,
} from "../../utils/bottom-sheet-manager.js";

async function loadGallery(id) {
  const galleryContainer = els.industryInfo.querySelector("#industry_gallery");
  galleryContainer.style.display = "none";

  try {
    const data = await ApiService.ajax("load_industry_gallery", { id });
    galleryContainer.innerHTML = data;
    const image_swiper = new Swiper("#industry_gallery .swiper", {
      modules: [Navigation, Pagination, Autoplay],
      loop: false,
      slidesPerView: 3,
      spaceBetween: 5,
      observer: true,
      observeParents: true,
      pagination: {
        el: "#industry_gallery .swiper-pagination",
        clickable: true,
      },
      autoplay: {
        delay: 5000,
      },
      navigation: {
        nextEl: "#industry_gallery .swiper-button-next",
        prevEl: "#industry_gallery .swiper-button-prev",
      },
      on: {
        afterInit: function () {
          galleryContainer.style.display = "block"; // Or a slideDown-like effect
          Fancybox.bind('[data-fancybox="gallery"]', {
            // Your custom options here
          });
        },
      },
    });
  } catch (error) {
    console.error("Error loading gallery:", error);
  }
}

export async function moveToLocation(id) {
  console.log("🚀 moveToLocation called with ID:", id);

  // Validate map instance
  if (!state.map) {
    console.error("❌ Map instance not available in state");
    return false;
  }

  toggleLoading(true);
  var userCollection = getCookie("user_collection");

  if (state.boundaryLayer) {
    state.boundaryLayer.setStyle({ fillOpacity: 0 });
  }

  const apiUrl = `${window.location.origin}/wp-json/wp/v2/industry/${id}`;
  console.log("📡 Fetching data from:", apiUrl);

  try {
    const { data } = await ApiService.fetch(apiUrl);
    console.log("✅ Data fetched successfully:", data.title.rendered);

    const inID = data.id;
    const lat = parseFloat(data.acf.industry_lat);
    const long = parseFloat(data.acf.industry_long);
    const title = data.title.rendered;
    const content = data.content.rendered;
    const youtube_url = data.acf.industry_youtube;
    const imgSrc = data.featured_image_url;
    let searchStr = document.body.dataset.searchStr;

    console.log("📍 Coordinates:", lat, long);

    // Validate coordinates
    if (isNaN(lat) || isNaN(long)) {
      console.error("❌ Invalid coordinates:", lat, long);
      toggleLoading(false);
      return false;
    }

    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = content;
    tempDiv.querySelectorAll("table").forEach(function (table) {
      const wrapper = document.createElement("div");
      wrapper.className = "table-responsive overflow-x-auto max-w-full";
      table.parentNode.insertBefore(wrapper, table);
      wrapper.appendChild(table);
    });

    tempDiv
      .querySelectorAll("table, table th, table td, table tr, table thead, table tbody")
      .forEach((el) => {
        el.removeAttribute("style");
        el.removeAttribute("class");
      });
    let updatedContent = tempDiv.innerHTML;

    if (searchStr) {
      const pattern = createDiacriticPattern(searchStr);
      const regex = new RegExp(pattern, "gi");
      updatedContent = updatedContent.replace(regex, function (matched) {
        return `<mark class="highlight">${matched}</mark>`;
      });
    }

    const industryImg = document.createElement("img");
    industryImg.src = imgSrc;
    industryImg.className = "w-full h-auto aspect-square object-cover object-center rounded";
    els.industryInfo.querySelector("#thumbnail").innerHTML = "";
    els.industryInfo.querySelector("#thumbnail").appendChild(industryImg);
    els.industryInfo.querySelector("#industry-name").innerHTML = title;
    els.industryInfo.querySelector("#industry-content").innerHTML = updatedContent;

    // Safe element updates with null checks
    const viewGalleryEl = els.industryInfo.querySelector(".view-gallery");
    if (viewGalleryEl) {
      viewGalleryEl.setAttribute("data-id", inID);
    }

    const contactIpEl = els.industryInfo.querySelector(".contact-btn");
    if (contactIpEl) {
      contactIpEl.dataset.name = title;
    }

    const collectionBtnEl = els.industryInfo.querySelector(".collection-btn");
    if (collectionBtnEl) {
      collectionBtnEl.setAttribute("data-id", inID);
    }

    const viewVideoEl = els.industryInfo.querySelector(".view-video");
    if (viewVideoEl) {
      if (youtube_url) {
        viewVideoEl.setAttribute("href", youtube_url);
        viewVideoEl.style.display = "";
      } else {
        viewVideoEl.style.display = "none";
      }
    }

    loadGallery(inID);

    /* Social Share */
    const ipUrl = data.link;
    const shareThisBtnEl = els.industryInfo.querySelector(".share-this-btn");
    if (shareThisBtnEl) {
      shareThisBtnEl.setAttribute("data-url", ipUrl);
    }

    if (userCollection !== null) {
      var collectionItems = userCollection.split(",").map((item) => item.trim());
      let collectBtn;
      if (collectionItems.includes(inID.toString())) {
        collectBtn = els.industryInfo.querySelector(".add-to-collection");
        if (collectBtn) {
          collectBtn.classList.remove("add-to-collection");
          collectBtn.classList.add("remove-from-collection");
          const spanEl = collectBtn.querySelector("span");
          if (spanEl) {
            spanEl.textContent = mpsString.remove_from_collection_text;
          }
        }
      } else {
        collectBtn = els.industryInfo.querySelector(".remove-from-collection");
        if (collectBtn) {
          collectBtn.classList.remove("remove-from-collection");
          collectBtn.classList.add("add-to-collection");
          const spanEl = collectBtn.querySelector("span");
          if (spanEl) {
            spanEl.textContent = mpsString.add_to_collection_text;
          }
        }
      }
    }

    /* Show IP Detail */
    els.industryInfo.classList.add("shown");

    // Find and handle marker
    const existingMarker = findMarkerByLatLng(lat, long);
    console.log("🎯 Found marker:", existingMarker);

    if (state.boundaryLayer) {
      state.boundaryLayer.setStyle({ fillOpacity: 0 });
    }

    if (existingMarker) {
      console.log("🗺️ Moving map to coordinates:", lat, long);

      try {
        // Move map to location
        state.map.flyTo([lat, long], 14);
        console.log("✅ Map moved successfully");

        // Open popup
        existingMarker.openPopup();
        console.log("✅ Popup opened");

        // Update marker styling
        document
          .querySelectorAll(".leaflet-marker-icon")
          .forEach((m) => m.classList.remove("active"));

        const markerElement = existingMarker.getElement();
        if (markerElement) {
          markerElement.classList.add("active");
          console.log("✅ Marker styling updated");
        } else {
          console.warn("⚠️ Could not get marker element");
        }
      } catch (mapError) {
        console.error("❌ Error moving map:", mapError);
      }
    } else {
      console.warn("⚠️ No marker found for coordinates:", lat, long);
      // Still move map even if marker not found
      try {
        state.map.flyTo([lat, long], 14);
        console.log("✅ Map moved to coordinates (no marker)");
      } catch (mapError) {
        console.error("❌ Error moving map:", mapError);
      }
    }

    toggleLoading(false);
    return true;
  } catch (error) {
    console.error("❌ Error in moveToLocation:", error);
    toggleLoading(false);
    return false;
  }
}

export function setupEventListeners() {
  // Setup reset-map button listener (created by initMap)
  const resetMapBtn = document.getElementById("reset-map");
  if (resetMapBtn) {
    resetMapBtn.addEventListener("click", function (e) {
      e.preventDefault();
      els.industryInfo.classList.remove("shown");
      els.industries.classList.remove(
        "industry-info-actived",
        "province-info-actived",
        "contact-ip-actived",
      );
      resetMap();
    });
  }

  // Use event delegation for all dynamic elements in industries container
  els.industries.addEventListener("click", function (e) {
    // Handle view-location clicks
    const viewLocation = e.target.closest(".view-location");
    if (viewLocation) {
      e.preventDefault();
      var id = viewLocation.dataset.id;
      moveToLocation(id);
      els.industries.classList.add("industry-info-actived");
      expandBottomSheet();
    }

    // Handle province info readmore clicks
    const readmoreBtn = e.target.closest(".province-info .readmore");
    if (readmoreBtn) {
      e.preventDefault();
      els.provinceInfoFull.classList.add("active");
      els.industries.classList.add("province-info-actived");
    }

    // Handle province info full close clicks
    const closeBtn = e.target.closest("#province-info-full .close");
    if (closeBtn) {
      e.preventDefault();
      els.provinceInfoFull.classList.remove("active");
      els.industries.classList.remove("province-info-actived");
    }

    // Handle industry info close clicks
    const industryCloseBtn = e.target.closest("#industry-detail .close");
    if (industryCloseBtn) {
      e.preventDefault();
      els.industryInfo.classList.remove("shown");
      els.industries.classList.remove("industry-info-actived");
      resetMap();
    }

    // Handle contact button clicks
    const contactBtn = e.target.closest(".contact-btn");
    if (contactBtn) {
      e.preventDefault();
      els.industries.classList.add("contact-ip-actived");
      fullScreenBottomSheet();
    }

    // Handle register form close clicks
    const registerCloseBtn = e.target.closest(".register-form .close");
    if (registerCloseBtn) {
      e.preventDefault();
      els.industries.classList.remove("contact-ip-actived");
      expandBottomSheet();
    }
  });

  // Use event delegation for hover events
  els.industries.addEventListener("mouseover", function (e) {
    const viewLocation = e.target.closest(".view-location");
    if (viewLocation) {
      e.preventDefault();
      var id = viewLocation.dataset.id;
      var marker = document.querySelector(`.leaflet-marker-icon[alt='${id}']`);
      document.querySelectorAll(".leaflet-marker-icon").forEach((m) => (m.style.opacity = "0.1"));
      if (marker) {
        marker.style.opacity = "1";
        marker.dispatchEvent(new MouseEvent("hover"));
      }
    }
  });

  els.industries.addEventListener("mouseout", function (e) {
    const viewLocation = e.target.closest(".view-location");
    if (viewLocation) {
      document.querySelectorAll(".leaflet-marker-icon").forEach((m) => (m.style.opacity = "1"));
    }
  });

  // Use event delegation for .iphub-marker clicks (already optimized)
  els.mapElement.addEventListener("click", function (e) {
    const markerElement = e.target.closest(".iphub-marker");
    if (markerElement) {
      e.preventDefault();

      if (!state.navigationActivated) {
        var id = markerElement.getAttribute("alt");

        if (id) {
          moveToLocation(id);
          els.industries.classList.add("industry-info-actived");
          expandBottomSheet();
        }
      }
    }
  });

  // Handle keyboard events for accessibility
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") {
      // Close any open panels
      els.industryInfo.classList.remove("shown");
      els.provinceInfoFull.classList.remove("active");
      els.industries.classList.remove(
        "industry-info-actived",
        "province-info-actived",
        "contact-ip-actived",
      );
      resetMap();
    }
  });
}
